// @flow
import React from 'react';
import styled from 'styled-components';
import {
  isValidFileType,
  showAcceptFileTypes
} from 'validations/HomieValidations';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  & input[type='file'] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
`;

type PropsType = {
  accept: string,
  multipleFile: boolean,
  onSelectFiles: (files: Array<File>) => void,
  onError: (message: string) => void,
  clearError: () => void
};

export default class DropZoneUploadFileComponent extends React.Component<PropsType> {
  static defaultProps = {
    multipleFile: true
  };

  onSelectFiles = (e: any) => {
    e.preventDefault();
    let files = [];
    let countErrors = 0;
    for (let i = 0; i < e.target.files.length; ++i) {
      if (this.props.accept === undefined) {
        files.push(e.target.files[i]);
      } else if (isValidFileType(e.target.files[i], this.props.accept)) {
        files.push(e.target.files[i]);
      } else {
        countErrors += 1;
      }
    }
    if (countErrors > 0) {
      this.props.onError(
        `Ingresa un tipo de archivo válido. (${showAcceptFileTypes(
          this.props.accept
        )})`
      );
    } else {
      this.props.clearError();
    }
    this.props.onSelectFiles(files);
    e.target.value = null;
  };

  render() {
    const { accept, multipleFile } = this.props;
    return (
      <Container>
        <input
          accept={accept}
          type="file"
          onChange={this.onSelectFiles}
          multiple={multipleFile}
        />
      </Container>
    );
  }
}
